<template>
  <el-card class="expert-card" hoverable v-if="expert" @click="goToDetail(expert)">
    <div class="expert-info">
      <img
        :src="expert.avatar || defaultExpertImg"
        :alt="expert.name"
        class="expert-avatar"
        @error="handleAvatarError">
      <div class="expert-details">
        <h3 class="expert-name">{{ expert.name }} <span v-if="expert.titles" class="title-tag">{{ expert.title }}</span>
        </h3>
        <p class="expert-fields">研究领域: {{ expert.researchFields ? expert.researchFields.split(',').join(',') : '未填写' }}
        </p>

      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'ExpertItem',
  props: {
    expert: {
      type: Object,
      required: true,
      validator: (value) => {
        return value && typeof value === 'object' && 'id' in value && 'name' in value;
      }
    },
    introMaxLength: {
      type: Number,
      default: 80
    }
  },
  data() {
    return {
      defaultExpertImg: require('@/assets/defaultImg/default-expert.png'),
    }
  },
  methods: {
    handleAvatarError(e) {
      console.log(1)
      if (e.target.src !== this.defaultExpertImg) {
        e.target.onerror = null;
        e.target.src = this.defaultExpertImg;
      }
    },
    truncateIntroduction(intro) {
      if (intro.length <= this.introMaxLength) {
        return intro;
      }
      return `${intro.slice(0, this.introMaxLength)}...`;
    },
    goToDetail(expert) {
      // 跳转到专家详情页并传递专家ID参数
      this.$router.push({
        name: 'ExpertDetail',
        params: { id: expert.id }
      });
    },
  }
};
</script>

<style scoped>
.expert-card {
  transition: all 0.3s ease;
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  /* 固定卡片高度，确保一致性 */
  height: 200px;
  display: flex;
  margin: 10px;
  flex-direction: column;
}

.expert-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12);
}

.expert-info {
  display: flex;
  align-items: flex-start;
  padding: 15px;
  flex: 1;
  /* 让内容区域填充卡片 */
}

.expert-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 15px;
  border: 3px solid #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
  /* 防止头像被压缩 */
}

.expert-details {
  flex: 1;
  min-width: 0;
  /* 解决内容溢出问题 */
  display: flex;
  flex-direction: column;
}

.expert-name {
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.title-tag {
  margin-left: 8px;
  font-size: 12px;
  padding: 2px 6px;
  background-color: #eff6ff;
  color: #3b82f6;
  border-radius: 4px;
}

.expert-fields {
  color: #4b5563;
  margin: 0 0 10px 0;
  font-size: 14px;
  line-height: 1.5;
  /* 处理过长的研究领域 */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 42px;
  /* 确保两行高度 */
}

.expert-intro {
  color: #6b7280;
  font-size: 13px;
  line-height: 1.6;
  margin: 0;
  /* 固定简介区域高度，显示3行 */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  flex: 1;
  /* 填充剩余空间 */
}

/* 占位文本样式 */
.placeholder {
  color: #9ca3af;
  font-style: italic;
}
</style>
